import React from 'react';

const TikTokIcon = () => {
  return (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="37.024" height="37.024" rx="10.68" fill="#F6F6F6" />
      <path
        d="M23.3 12.27C24.62 13.18 26.13 13.73 27.76 13.84V10.91C26.9 10.85 26.08 10.61 25.34 10.2C24.56 9.75 23.89 9.1 23.39 8.31C23.07 7.78 22.86 7.21 22.76 6.61H19.99V20.34C19.99 21.21 19.52 22.02 18.75 22.47C17.98 22.92 17.01 22.96 16.2 22.58C15.39 22.21 14.85 21.46 14.74 20.61C14.61 19.61 15.09 18.66 15.94 18.17C16.47 17.88 17.06 17.78 17.62 17.88V15.04C15.26 14.93 13.06 16.53 12.57 18.82C12.11 21.03 13.24 23.29 15.32 24.2C17.48 25.16 20.09 24.39 21.43 22.43C21.99 21.61 22.31 20.63 22.31 19.62V13.02C22.67 13.12 23 13.22 23.3 13.27V12.27Z"
        fill="#191919"
      />
    </svg>
  );
};

export default TikTokIcon;
